import React, { useContext, useState, useEffect } from "react";
import ReactDOM from "react-dom";
import SingleProduct from "components/supplier/SingleProduct";
import Header from "components/supplier/Header";
import Partition from "components/supplier/Partition";
import Formatter from "hoc/Formatter";
import SinglePartition from "components/supplier/SinglePartition";
import SinglePartitionNew from "components/supplier/singlePartitionNew";
import SupplierContext from "context/SupplierContext";
import { connection } from "utils/apiConnection.ts";
import Contact from "components/supplier/Contact";
import logo from "../assets/images/bitamin.png";
import background from "../assets/images/background.png";
import cover1 from "assets/images/cover1.png";
import { useParams } from "react-router-dom";
import ParentSubLine from "components/supplier/ParentSubLine";
import SpecalBaskets from "components/landing/SpecialBaskets.tsx";
import Loader from "utils/Loader";
import { Discounters } from "components/supplier/SinglePartition";
import { AmazingSuggestion } from "components/supplier/SinglePartition";
const Supplier = ({ type }) => {
  const { sheep, calf, chicken, fish, shrimp } = useContext(SupplierContext);
  const [linesData, setLinesData] = useState([]);
  const [lines, setLines] = useState();
  const [linesList, setLinesList] = useState([]);
  const [subLine, setSubLine] = useState([]);
  const [coverImg, setCoverImg] = useState({});
  const [headers, setHeaders] = useState([{ id: "" }]);
  const [logo, setLogo] = useState("");
  const [product, setProduct] = useState([]);
  const [saleProduct, setSaleProduct] = useState([]);
  const [supplierBasket, setSupplierBasket] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [updater1, setUpdater1] = useState(false);

  // console.log("linesData", linesData);
  // console.log("lines", lines);
  // console.log("linesList", linesList);

  let paramId = useParams();

  const typeBasket = "supplier";
  // useEffect(() => {
  //   (async () => {
  //     let temp2 = await connection("api/getlines", {
  //       supplier_id: paramId.supplier_id,
  //     });
  //     setLines([...temp2.lines]);
  //     let temp3 = await Promise.all(
  //       temp2.lines.map((value) => {
  //         return connection("api/get_products", {
  //           suppliers_line__id: 3,
  //           line_id: value.id,
  //         });
  //       })
  //     );
  //     console.log("temp3", temp3);
  //     setLinesData([...temp3]);
  //   })();
  //   connection("superadminapi/get_edit_suppliers_data", {
  //     supplier_id: 3,
  //   }).then((data) => {
  //     setHeaders(data.supplier);
  //     setCoverImg(data.cover_file[0].path);
  //     setLogo(data.logo_file[0].path);
  //   });
  // }, []);

  useEffect(() => {
    async function loadPage() {
      setLinesData([]);
      setLines([]);
      setLinesData([]);
      setHeaders([]);
      setCoverImg([]);
      setLogo([]);
      setSaleProduct([]);
      type != "line"
        ? await connection("api/getlines", {
            supplier_id: paramId.supplier_id,
          }).then((data) => {
            setLines(data.lines);
            setLinesList(data.lines);
            data.lines?.map((value) => {
              connection("api/get_products", {
                supplier_id: paramId.supplier_id,
                line_id: value.main.suppliers_line__id,
              }).then((info) => {
                setLinesData((prev) => {
                  let temp = [
                    ...prev,
                    { title: value.main.title, value: info.data },
                  ];
                  return temp;
                });
              });
            });
          })
        : await connection("api/getlines", { cat_id: paramId.lineId }).then(
            (data) => {
              setLines(data.lines);
              setLinesList(data.lines);
              data.lines?.map((value) => {
                connection("api/get_products", {
                  line_id: value.main.suppliers_line__id,
                }).then((info) => {
                  setLinesData((prev) => {
                    let temp = [
                      ...prev,
                      { title: value.main.title, value: info.data },
                    ];
                    return temp;
                  });
                });
              });
            }
          );

      type != "line" &&
        (await connection("superadminapi/get_edit_suppliers_data", {
          supplier_id: paramId.supplier_id,
        }).then((data) => {
          setHeaders(data.supplier);
          setCoverImg(data.cover_file?.length > 0 && data.cover_file[0].path);
          setLogo(data.logo_file?.length > 0 && data.logo_file[0].path);
        }));
      type != "line" &&
        (await connection("api/get_products", {
          has_discount: true,
          supplier_id: paramId.supplier_id,
        }).then((data) => {
          setSaleProduct(data.data);
        }));
      setIsLoading(false);

      // api basket
      // connection("supplier/get_basket_with_items",{supplier_id: paramId.supplier_id}).then(data => {
      //   setSupplierBasket(data.data);

      //   console.log("data2 : ", data);
      // });
    }
    loadPage(); // clear states
  }, [paramId.supplier_id, updater1]);

  const [information, setInformation] = useState([
    {
      buttons: [
        { name: "همه", type: "0" },
        { name: "میوه", type: "1" },
        { name: "سبزی جات وصیفی جات", type: "2" },
      ],
      data: [
        {
          type: "1",
          img: cover1,
          title: "test",
          price: 12000,
          discount: 3000,
          desc: "نگال یکبارمصرف 12 عددی درفین نگال یکبارمصرف 12 عددی درفین",
        },
        {
          type: "1",
          img: cover1,
          title: "test",
          price: 12000,
          discount: 37000,
          desc: "چنگال یکبارمصرف 12 عددی درفین",
        },
        {
          type: "1",
          img: cover1,
          title: "test3",
          price: 12000,
          discount: 36000,
          desc: "کیسه فریزر100 عددی پینگو",
        },
        {
          type: "2",
          img: cover1,
          title: "test4",
          price: 12000,
          discount: 32000,
          desc: "نگال یکبارمصرف 12 عددی درفین 100 عددی پینگو",
        },
        {
          type: "2",
          img: cover1,
          title: "test4",
          price: 12000,
          discount: 32000,
          desc: "نگال یکبارمصرف 12 عددی درفین 100 عددی پینگو",
        },
        {
          type: "2",
          img: cover1,
          title: "test4",
          price: 12000,
          discount: 32000,
          desc: "نگال یکبارمصرف 12 عددی درفین 100 عددی پینگو",
        },
      ],
      title: "میوه",
    },
    {
      buttons: [{ name: "همه" }, { name: "سوییس" }, { name: "کالباس " }],
      data: [
        {
          type: "1",
          img: cover1,
          title: "test",
          price: 12000,
          discount: 3000,
          desc: "11",
        },
        {
          type: "1",
          img: cover1,
          title: "test",
          price: 12000,
          discount: 37000,
          desc: "22",
        },
        {
          type: "1",
          img: cover1,
          title: "test3",
          price: 12000,
          discount: 36000,
          desc: "33",
        },
        {
          type: "2",
          img: cover1,
          title: "test4",
          price: 12000,
          discount: 32000,
          desc: "نگال یکبارمصرف 12 عددی درفین 100 عددی پینگو",
        },
        {
          type: "2",
          img: cover1,
          title: "test4",
          price: 12000,
          discount: 32000,
          desc: "نگال یکبارمصرف 12 عددی درفین 100 عددی پینگو",
        },
        {
          type: "2",
          img: cover1,
          title: "test4",
          price: 12000,
          discount: 32000,
          desc: "نگال یکبارمصرف 12 عددی درفین 100 عددی پینگو",
        },
      ],
      title: "پروتئینی",
    },
  ]);
  const [selectedItem, setSelectedItem] = useState(-1);
  const changeSelectedItem = (index) => setSelectedItem(index);
  const filterDataLine = (id) => {
    setLines(linesList.filter((d) => d.main.suppliers_line__id != id));
  };
  const subLines = (id) => {
    let temp = linesList.filter((d) => d.main.suppliers_line__id == id);
    setSubLine(temp[0]);
  };
  const productList = (id, typeLine) => {
    async function loadPage() {
      type != "line" &&
        typeLine == "apiLine" &&
        (await connection("api/get_products", {
          supplier_id: paramId.supplier_id,
          line_id: id,
        }).then((data) => {
          setProduct(data);
        }));

      type != "line" &&
        typeLine == "apiSubLine" &&
        (await connection("api/get_products", {
          supplier_id: paramId.supplier_id,
          sub_line_id: id,
        }).then((data) => {
          setProduct(data);
        }));

      type == "line" &&
        typeLine == "apiLine" &&
        (await connection("api/get_products", {
          line_id: id,
        }).then((data) => {
          setProduct(data);
          // console.log("dataaaa", data);
        }));
      type == "line" &&
        (await typeLine) == "apiSubLine" &&
        connection("api/get_products", {
          sub_line_id: id,
        }).then((data) => {
          setProduct(data);
          // console.log("dataaaa", data);
        });
      setIsLoading(false);
    }
    loadPage();
  };

  const returnJSXBasedoneSelectedItem = () => {
    if (selectedItem == -1) {
      return (
        <>
          {isLoading && <Loader></Loader>}
          <div style={{ padding: "30px 6% 20px" }}>
            {saleProduct != undefined && saleProduct.length > 0 && (
              // <Formatter color={"#EF394E"} header="تخفیف دارها">
              <div
                className="d-flex w-100 "
                style={{ backgroundColor: "white", borderRadius: "50px" }}
              >
                {/* <AmazingSuggestion></AmazingSuggestion> */}

                <SinglePartition
                  data={saleProduct}
                  type="supplier"
                  typeSection="disconter"
                />
              </div>

              // </Formatter>
            )}
            {/* {type != "line" && ( */}
            <SpecalBaskets
              //  supplierBasket={supplierBasket}
              typeBasket={typeBasket}
            ></SpecalBaskets>
            {/* )} */}
          </div>

          {linesData.map((value, index) => {
            return (
              value.value != undefined && (
                <div style={{ padding: "10px 6% 0px" }}>
                  <Formatter color={"#5a3eff"} header={value.title}>
                    <div className="parent-singlePartion ">
                      <SinglePartition data={value.value} type="supplier" />
                    </div>
                  </Formatter>{" "}
                </div>
              )
            );
          })}
        </>
      );
    } else {
      return (
        <div className="parent-partion">
          <ParentSubLine
            // selectedInformation={information[selectedItem]}
            selectedInformation={filterDataLine}
            selectedItem={selectedItem}
            changeSelectedItem={changeSelectedItem}
            dataLine={lines}
            linesList={linesList}
            subLine={subLine}
            linesData={linesData}
            paramId={paramId.supplier_id}
            products={product}
            productList={productList}
          ></ParentSubLine>
        </div>
      );
    }
  };

  // console.log("linesData", linesData);
  // console.log("heder:", headers);
  // console.log("lines", lines);

  // console.log("selectedItem", selectedItem);
  // console.log("linelist", linesList);
  // console.log("subLine", subLine);
  // console.log("productSupp", product);
  // console.log("saleProduct", saleProduct);
  // console.log("paramId", paramId.supplier_id);

  return (
    <div>
      <Contact></Contact>
      <div style={{ backgroundColor: "#f4eeea" }}>
        {type != "line" && (
          <Header
            headers={headers}
            setHeaders={setHeaders}
            coverImg={coverImg}
            setCoverImg={setCoverImg}
            logo={logo}
            setLogo={setLogo}
            cover={cover1}
          ></Header>
        )}
        <div style={{ padding: "20px 6% 20px" }}>
          {linesData.length > 0 ? (
            <Formatter color={"#5a3eff"} header={"لاین محصولات"}>
              <div className="parent-partion ">
                <Partition
                  selectedItem={selectedItem}
                  changeSelectedItem={changeSelectedItem}
                  dataLine={lines}
                  linesList={linesList}
                  filterDataLine={filterDataLine}
                  subLines={subLines}
                  productList={productList}
                />
              </div>
            </Formatter>
          ) : (
            "در حال حاضر این فروشگاه لاینی ندارد"
          )}
        </div>

        {returnJSXBasedoneSelectedItem()}
      </div>
      {ReactDOM.createPortal(
        <>
          <SingleProduct
            updater1={updater1}
            setUpdater1={setUpdater1}
            data={saleProduct}
            type="supplier"
          />
        </>,
        document.getElementById("modals")
      )}
    </div>
  );
};

export default Supplier;
